<template>
  <div id="chart">
    <apexchart
      type="bar"
      height="300px"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  name: "ColumnChart",
  props: {
    series: Array,
    labels: Array,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            borderRadius: 5,
            borderRadiusApplication: 'end'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.labels,
        },
        yaxis: {
          title: {
            text: ''
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        }
      },
    }
  }
};
</script>

<style lang="scss" scoped></style>
